module.exports = __webpack_public_path__ + "img/candle.7cd9ce1b.gif";